export enum OrderStatus {
  created = 'created',
  waiting = 'waiting',
  ongoing = 'ongoing',
  delivered = 'delivered',
  cancelled = 'cancelled',
  refunded = 'refunded',
  paid = 'paid',
}

export enum EventTicketStatus {
  refunded = 'refunded',
  pending = 'pending',
  accepted = 'accepted',
  used = 'used',
  canceled = 'canceled',
}

export enum FriendNotificationType {
  friendshipRequest = 'friendship_request',
  friendshipAccepted = 'friendship_accepted',
  friendshipRejected = 'friendship_rejected',
  friendWonCredits = 'friend_won_credits',
  placeBestCustomer = 'place_best_customer',
}

export enum FriendStatus {
  pending = 'pending',
  accepted = 'accepted',
  rejected = 'rejected',
}

export enum AdminStatInterval {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
}

export enum EventEntryType {
  Private = 'private',
  Public = 'public',
}

export enum AdminPlaceType {
  Bar = 'bar',
  School = 'school',
  All = 'all',
}

export enum Gender {
  male = 'male',
  female = 'female',
  other = 'other',
}

export enum UserSource {
  web = 'web',
  mobile = 'mobile',
}

export enum ShakerType {
  sharingShaker = 'sharing_shaker',
  sharedShaker = 'shared_shaker',
  shaker = 'shaker',
}

export enum DiscountType {
  flat = 'flat',
  percentage = 'percentage',
}

export enum OrderNotificationType {
  orderCancelled = 'order_cancelled',
}

export enum PaymentMethodType {
  card = 'card',
  applepay = 'applepay',
  googlepay = 'googlepay',
  credits = 'credits',
}

export enum PaymentStatus {
  awaiting = 'awaiting',
  rejected = 'rejected',
  authorized = 'authorized',
  accepted = 'accepted',
  cancelled = 'cancelled',
  refunding = 'refunding',
  refunded = 'refunded',
}

export enum UserVisibility {
  private = 'private',
  public = 'public',
}

export enum UserOutPartyStatus {
  pending = 'pending',
  inReview = 'in_review',
  validated = 'validated',
  blocked = 'blocked',
}

export enum SharedShakerNotificationType {
  receivedSharedShaker = 'received_shared_shaker',
  receivedSharedShakerReminder = 'received_shared_shaker_reminder',
}

export enum DrinkNotificationType {
  drinkOffer = 'someone_offered_drink',
  offerReminder = 'someone_offered_drink_reminder',
  offeredDrinkAccepted = 'offered_drink_accepted',
  offeredDrinkDeclined = 'offered_drink_declined',
}

export enum OutPartyNotificationType {
  guestExpiredPartyRequest = 'guest_expired_party_request',
  newPartyAnswer = 'new_party_answer',
}

export enum ActivityNotification {
  activityChanged = 'activity_changed',
}

export enum EventType {
  private = 'private',
  public = 'public',
}

export enum PlaceStatus {
  cancelled = 'cancelled',
  validated = 'validated',
  registered = 'registered',
  waitingforvalidation = 'waitingforvalidation',
  not_partner = 'not_partner',
}

export enum StudentUnionMemberRole {
  president = 'president',
  vicePresident = 'vice_president',
  treasurer = 'treasurer',
  sponsorManager = 'sponsor_manager',
  communicationManager = 'communication_manager',
  administrationMember = 'administration_member',
  other = 'other',
}

export enum EventNotification {
  ticketRefunded = 'event_ticket_refunded',
}

export enum Wholesale {
  limitedOne = 0,
  notLimited = 1,
}

export enum UserNotification {
  creditExpiration = 'credit_expiration',
}

export enum UserDataNotification {
  changed = 'user_changed',
}

export enum NotificationAction {
  openOrdersTab = 'open-orders',
  openDrinkOffer = 'open-drink-offer',
  openUserProfile = 'open-user-profile',
  openFriendProfile = 'open-friend-profile',
  openPlaceMenu = 'open-place-menu',
  openActivityFeed = 'open-activity-feed',
  openGiftSharedShaker = 'open-gift-shared-shaker',
  openOutParty = 'open-out-party',
  openOutPartyAvailableHosts = 'open-out-party-available-hosts',
}

export enum PlaceType {
  bar = 'bar',
  club = 'club',
  school = 'school',
  restaurant = 'restaurant',
  eventOrganizer = 'event_organizer',
  festival = 'festival',
  happyHour = 'happyHour',
}

export enum PlaceSubscriptionType {
  none = 'none',
  paused = 'paused',
  blue = 'blue',
  gold = 'gold',
  black = 'black',
}

export enum ProductCategoryName {
  aperitifs = 'aperitifs',
  beersCiders = 'beers-ciders',
  hotDrinks = 'hot-drinks',
  bottles = 'bottles',
  champagne = 'champagne',
  coctails = 'coctails',
  cocktailCreation = 'cocktail-creation',
  nonAlcoholCocktails = 'non-alcoholic-cocktails',
  food = 'food',
  gin = 'gin',
  shooters = 'shooters',
  soft = 'soft',
  wines = 'wines',
  other = 'other',
  spirits = 'spirits',
  vodka = 'vodka',
  rhum = 'rhum',
  whisky = 'whisky',
  tequila = 'tequila',
  search = 'search',
}

export enum ActivityType {
  friendRequest = 'friendship_request',
  like = 'like',
  drink = 'drink_offered_by_other_user',
  event = 'event_ticket_bought',
  coins = 'order_coins_received',
  friendCredits = 'friend_won_credits',
  friendBestCustomer = 'friend_became_place_best_customer',
  friendInBar = 'friend_showed_up_at_place',
  creditExpiration = 'credit_expiration',
  receivedSharedShaker = 'received_shared_shaker',
}

export enum PartyRequestHostType {
  bar = 'bar',
  club = 'club',
  restaurant = 'restaurant',
}

export enum PartyRequestType {
  afterwork = 'afterwork',
  party = 'party',
  gala = 'gala',
  openAir = 'open_air',
  festival = 'festival',
  birthday = 'birthday',
  seminar = 'seminar',
  other = 'other',
}

export enum PartyRequestDjStatus {
  noNeed = 'no_need',
  hasDj = 'has_dj',
  needDj = 'need_dj',
}

export enum PartyRequestStatus {
  draft = 'draft',
  inReview = 'in_review',
  published = 'published',
  accepted = 'accepted',
  finished = 'finished',
  cancelled = 'cancelled',
  blocked = 'blocked',
}

export enum PartyRequestPrivacy {
  public = 'public',
  partiallyPrivate = 'partially_private',
  private = 'private',
}

export enum PartyAnswerStatus {
  draft = 'draft',
  pending = 'pending',
  won = 'won',
  lost = 'lost',
  finishedWon = 'finished_won',
  finishedLost = 'finished_lost',
  cancelled = 'cancelled',
}

export enum SocialMediaType {
  facebook = 'facebook',
  tiktok = 'tiktok',
  instagram = 'instagram',
  snapchat = 'snapchat',
  twitter = 'twitter',
  linkedin = 'linkedin',
  youtube = 'youtube',
  reddit = 'reddit',
  whatsapp = 'whatsapp',
  telegram = 'telegram',
  discord = 'discord',
  twitch = 'twitch',
}

export enum ServiceTable {
  counter = 'counter',
}
